module.exports = __webpack_public_path__ + "static/media/staff.0352cebe.png";